import { __assign, __rest } from "tslib";
import React from 'react';
import { transformWireframeProps } from '../../../../../../../../utils/propUtils';
var VeltNotificationsPanelSettingsAccordionContentItemLabelWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-notifications-panel-settings-accordion-content-item-label-wireframe", __assign({}, transformedProps), children));
};
export default VeltNotificationsPanelSettingsAccordionContentItemLabelWireframe;
